import React from 'react';
import team1 from '../assets/img/team1.png'
import team2 from '../assets/img/team2.png'

// import about data
import { aboutData } from '../data';

const Team = () => {
  // destructure about
  const { image, title, subtitle } = aboutData;
  return (
    <section
      className='my-[30px] pt-[50px] xl:mt-[100px]'
      data-aos='fade-up'
      data-aos-offset='350'
    >
      <div className='container mx-auto'>
        <div className='bg-accent-about rounded-[50px] min-h-[560px] px-12 pb-12 pt-12 flex-col text-center xl:flex-row xl:items-center xl:text-left  xl:gap-x-[60px] xl:pb-0'>
        <div className='text-center'>
          <h2
            className='h2 mb-6 xl:mb-12'
            data-aos='fade-down'
            data-aos-delay='100'
          >
            Meet Our Team
          </h2>
          </div>
          {/* image */}
          <div className='flex-1 flex-row' data-aos='zoom-in-left'>
            <div className="flex flex-col bg-white rounded-lg shadow-md w-full m-6 overflow-hidden sm:w-52">
              <img src={team1} alt='' className='m-6' />
              <h2 className="text-center text-secondary font-secondary font-bold px-2 pb-5">Faisal Rahman</h2>
                <a href="https://faisalongit.github.io/react-portfolio/" className="bg-accent-primary text-white p-3 text-center hover:bg-accent-secondary transition-all duration-500">Know More</a>
            </div>
            <div className="flex flex-col bg-white rounded-lg shadow-md w-full m-6 overflow-hidden sm:w-52">
              <img src={team2} alt='' className='m-6' />
              <h2 className="text-center text-secondary font-secondary font-bold px-2 pb-5">Aria Priawan Yahya</h2>
                <a href="https://ariapriawannn.github.io/" className="bg-accent-primary text-white p-3 text-center hover:bg-accent-secondary transition-all duration-500">Know More</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Team;
